<script setup lang="ts">
import { RouterView } from 'vue-router'
import { useRoute } from 'vue-router'
import { watch, ref, computed } from 'vue'

const includeList = ref<any>([])
const route = useRoute()

watch(() => route,(newVal:any)=>{
  if(newVal.meta.keepAlive && includeList.value.indexOf(newVal.name) === -1){
    includeList.value.push(newVal.name);
  }
},{deep:true})
</script>

<template>
  <RouterView v-slot="{ Component }" >
    <keep-alive :include="includeList">
      <component :is="Component"/>
    </keep-alive>
	</RouterView>
</template>


<style lang="scss" scoped>

</style>